module.exports = {"dateFrom":"from {start}","dateFromTo":"from {start} to {end}"}